// encode text area value just before sending it to the server
const form = document.querySelector('.js-application-form');
const textareas = form?.querySelectorAll('textarea[name]');

// Converts any string into a UTF-8 encoded Base64 string
const encodeText = str => (
  window.btoa(
    Array.from(
      new TextEncoder().encode(str),
      byte => String.fromCodePoint(byte)
    ).join('')
  )
);

if (form && textareas?.length) {
  form.addEventListener('formdata', event => {
    textareas.forEach(textarea => {
      event.formData.set(
        textarea.name,
        encodeText(event.formData.get(textarea.name))
      );
    })
  })
}